import axios from "axios";
import { isExpiredSessionError, logoutExpiredSession } from "./sessionExpiry";

let ROOT_URL = "";
let IMAGE_URL = "";
let WEB_URL = "";
//let BEAM_URL = "http://localhost:3000/api";
let BEAM_URL = "https://bs.tcgdob.com/api";

ROOT_URL = "https://api.tcgdob.com/api/v1";
WEB_URL = "https://tcgdob.com";

// BEAM_URL = "http://localhost:3000/api";

// Pages that call beam-service directly with plain axios (not authAxios)
// don't get auto-logged-out on an expired token without this.
axios.interceptors.response.use(
    (response) => response,
    (error) => {
        if (isExpiredSessionError(error)) {
            logoutExpiredSession();
        }
        return Promise.reject(error);
    },
);

export { IMAGE_URL, WEB_URL, BEAM_URL };
export default ROOT_URL;

